module.exports = __webpack_public_path__ + "img/image.a3bb68a8.png";